module.exports = __webpack_public_path__ + "static/media/Design sans titre (3).6f2c9da1.png";